import { render, staticRenderFns } from "./FilterCatalogLevel3.vue?vue&type=template&id=c64536b4&"
import script from "./FilterCatalogLevel3.vue?vue&type=script&lang=js&"
export * from "./FilterCatalogLevel3.vue?vue&type=script&lang=js&"
import style0 from "./FilterCatalogLevel3.vue?vue&type=style&index=0&id=c64536b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports